module.exports = __webpack_public_path__ + "img/cce037d.png";